"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GooglePlusIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.078 7.085V9.1s1.95-.004 2.747-.004c-.431 1.306-1.098 2.017-2.747 2.017-1.668 0-2.967-1.352-2.967-3.023 0-1.67 1.303-3.023 2.967-3.023.883 0 1.452.31 1.974.743.42-.42.385-.48 1.448-1.486A5.066 5.066 0 005.082 3 5.088 5.088 0 000 8.09a5.088 5.088 0 005.082 5.092c4.195 0 5.22-3.66 4.878-6.097H5.078zm9.16.098V5.418h-1.256v1.765h-1.81V8.44h1.81v1.812h1.256V8.441H16V7.183h-1.762z"
  })))
});
GooglePlusIcon.displayName = 'GooglePlusIcon';
var _default = exports.default = GooglePlusIcon;